/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function TableColumnsIcon(props: IconProps) {
    return <IconWrapper {...props}>{<path d="M7 30c0 .563.438 1 1 1h10.5V14H7zm14.5 1H32c.5 0 1-.437 1-1V14H21.5zM8 6h24c2.188 0 4 1.813 4 4v20c0 2.25-1.812 4-4 4H8c-2.25 0-4-1.75-4-4V10c0-2.187 1.75-4 4-4"/>}</IconWrapper>;
}
